import {Injectable} from '@angular/core';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';
import {ReadingSpeedEnum} from '@core/enums/reading-speed.enum';

@Injectable()
export class TtsHelperService {

    removeSSML(text?: string): string {
        return text ? text.replace(/<mat-icon .*?>(.*?)<\/mat-icon>/gi, '')
            .replace(/&uarr;/g, ' ')
            .replace(/&reg;/g, ' ')
            .replace(/<br>/g, ' ')
            .replace(/(<([^>]+)>)/gi, '')
            .replace('.', '. ')
            .replace(':', '.') : '';
    }

    removeHTMLTags(text?: string): string {
        return text ? text.replace(/(<([^>]+)>)/gi, '') : '';
    }

    getReadingSpeedByLanguageStyle(languageStyle?: LanguageStyleEnum): ReadingSpeedEnum {
        switch (languageStyle) {
            case LanguageStyleEnum.STANDARD:
                return ReadingSpeedEnum.MEDIUM;
            case LanguageStyleEnum.SIMPLE:
                return ReadingSpeedEnum.SLOW;
            case LanguageStyleEnum.EASY:
                return ReadingSpeedEnum.SLOW;
            default:
                return ReadingSpeedEnum.MEDIUM;
        }
    }
}
